<div class="footer-copyright">
    <!-- <p><a href="#">Terms of Use</a> | <a href="#">Privacy Policy</a></p> -->
    <p>Copyright &copy; {{ currentYear }} The Dow Chemical Company</p>
</div>
